import Moment from 'moment'
import sha256 from 'sha256'
import contentItem from './contentItem'
import commonData from './common-data'
import router from '../router/index'
import EXIF from 'exif-js'
import $cErrorDialog from '../components/Dialog/cErrorDialog'
import crypto from 'crypto';

export default {
  // 本地保存
  saveLocalData: function (name, data, orderName) {
    let alreadysave, obj = {}
    if (orderName) {//存另外的一个对象
      alreadysave = JSON.parse(localStorage.getItem(orderName));
    } else {
      alreadysave = JSON.parse(localStorage.getItem('stoData'));
    }

    if (alreadysave) {
      obj = Object.assign(alreadysave, {[name]: data});
    } else {
      obj = {[name]: data};
    }

    if (orderName) {
      localStorage.setItem(orderName, JSON.stringify(obj));
    } else {
      localStorage.setItem('stoData', JSON.stringify(obj));
    }
  },
  // 本地获取
  getLocalData: function (name, orderName) {
    let data
    if (orderName) {
      data = JSON.parse(localStorage.getItem(orderName));
    } else {
      data = JSON.parse(localStorage.getItem('stoData'));
    }
    if (data == null) return false;
    if (data[name] == undefined) return false;
    return data[name];
  },
  //stoData下面的某个对象
  saveLocalLowerData: function (name, data, orderName, storageItemName = 'stoData') {
    let alreadysave = JSON.parse(localStorage.getItem(storageItemName));
    let obj = {[name]: data}

    if (alreadysave) {
      let data = alreadysave[orderName];
      if (data) {
        let data1 = Object.assign(data, obj);
        obj = Object.assign(alreadysave, {[orderName]: data1});
      } else {
        obj = Object.assign(alreadysave, {[orderName]: obj});
      }
    } else {
      obj = Object.assign({}, {[orderName]: obj});
    }

    localStorage.setItem(storageItemName, JSON.stringify(obj));
  },

  getLocalLowerData: function (name, orderName, storageItemName = 'stoData') {
    let data = JSON.parse(localStorage.getItem(storageItemName));
    if (data == null) return false;
    if (data[orderName] == undefined) return false;
    if (data[orderName][name] == undefined) return false;
    return data[orderName][name];
  },

  // 在提出本地保存Session
  saveSessionData: function (name, data, orderName) {
    let alreadysave, obj = {}
    if (orderName) {//存另外的一个对象
      alreadysave = JSON.parse(sessionStorage.getItem(orderName));
    } else {
      alreadysave = JSON.parse(sessionStorage.getItem('resetCorporateData'));
    }

    if (alreadysave) {
      obj = Object.assign(alreadysave, {[name]: data});
    } else {
      obj = {[name]: data};
    }

    if (orderName) {
      sessionStorage.setItem(orderName, JSON.stringify(obj));
    } else {
      sessionStorage.setItem('resetCorporateData', JSON.stringify(obj));
    }
  },
  // 本地获取
  getSessionData: function (name, orderName) {
    let data
    if (orderName) {
      data = JSON.parse(sessionStorage.getItem(orderName));
    } else {
      data = JSON.parse(sessionStorage.getItem('resetCorporateData'));
    }
    if (data == null) return false;
    if (data[name] == undefined) return false;
    return data[name];
  },
  saveReapplyDataSessionData: function (data) {
    let alreadysave, obj = {}
    alreadysave = JSON.parse(sessionStorage.getItem('resetData'));
    if (alreadysave) {
      obj = Object.assign(alreadysave, data);
    } else {
      obj = data;
    }
    sessionStorage.setItem('resetData', JSON.stringify(obj));
  },

  //加密密码(后期可能会换)
  hashPwd(pwd) {
    return sha256(pwd)
  },

  // 判断是ios,andriod
  judgeIosAndroid() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端或者uc浏览器
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    if (isAndroid) return false;
    if (isiOS) return true;
  },
  //计算年龄
  jsGetAge(birthYear, birthMonth, birthDay) {
    birthMonth = birthMonth.length == 1 ? '0' + birthMonth : birthMonth;
    birthDay = birthDay.length == 1 ? '0' + birthDay : birthDay;

    var nowYear = Moment(new Date()).format('YYYY'); //2019;
    var nowMonth = Moment(new Date()).format('MM');
    var nowDay = Moment(new Date()).format('DD');

    //同年 则为0岁
    if (nowYear == birthYear) {
      return 0;
    } else {
      var ageDiff = nowYear - birthYear; //年之差
      if (ageDiff > 0) {
        if (nowMonth == birthMonth) {
          //日之差
          return nowDay - birthDay < 0 ? ageDiff - 1 : ageDiff;
        }
        //月之差
        return nowMonth - birthMonth < 0 ? ageDiff - 1 : ageDiff;
      }
      return -1; //返回-1 表示出生日期输入错误 晚于今天
    }
  },
  // 电话号码验证
  VerifyTel(value) {
    const regTel = /^0\d{10}$/;
    return regTel.test(value)
  },
  //验证固定电话
  VerifyLandline(value) {
    const regTel = /^0\d{9,10}$/;
    return regTel.test(value)
  },
  // 获取顶部标题信息
  getTopTitle(router) {
    let fisrtString = router.substr(0, 1);
    let routeInfo =
      fisrtString == '/' ? router.substr(1) : router;
    return contentItem.titleObj[routeInfo];
  },
  //用于单选 清除已经选择的数据
  clearSelected(data) {
    return data.map((item) => {
      item.isActive = false;
      return item;
    });
  },
  //用于初次进入页面是，给选择框赋值
  putActiveData(data, activedata) {
    return data.map((item) => {
      if (item.id == activedata) {
        item.isActive = true;
      } else {
        item.isActive = false;
      }
      return item;
    });
  },
  // 获取选中的文本
  getActiveText(data, activedata) {
    if (activedata != '') {
      let result = data.find(item => {
        return item.id == activedata
      });
      return result.value
    } else {
      return ''
    }
  },
  //验证文本输入框
  verifyInputText(value, type = 1) {
    //(不包含)全角片假名,平假名,汉字，ー,a-z,a-z,々（全角）【姓名】
    let regexp1 = /[^\u30A1-\u30FC\u3040-\u309fー‐\u4E00-\u9FFF\u3005a-zａ-ｚA-ZＡ-Ｚ]+/;
    //全角片假名,ー,
    let regexp2 = /[^\u30A1-\u30FCー‐]+/;

    //全角片假名,平假名,－，汉字，ー,a-z（全角），数字（全角）(半角数字与字符必须输入框有转换全角功能),空格,々【住所地址】
    let regexp3 = /[^\u30A1-\u30FC－‐\u3040-\u309fー\u4E00-\u9FFFa-zａ-ｚA-ZＡ-Ｚ0-9０-９\u0020\u0030\u3005]+/;

    //番地输入规则 全角片假名,平假名,ー,a-z,ａ-ｚ,0-9，０-９,々,空格
    let regexp7 = /[^\u30A1-\u30FC－‐\u3040-\u309fー\u4E00-\u9FFFa-zａ-ｚA-ZＡ-Ｚ0-9０-９\u3005\u0020\u0030\u3000－\-]+/;

    //全角片假名,平假名,－，汉字，ー,a-z（A-Z）,空格,々【国名】
    let regexp4 = /[^\u30A1-\u30FC－‐\u3040-\u309fー\u4E00-\u9FFFa-zａ-ｚA-ZＡ-Ｚ\u0020\u0030\u3005\u002d\u3000]+/;

    //全角片假名(\u3040-\u30ff),平假名(\u3040-\u309f),半角片假名(\uff65-\uff9f),汉字(\u4E00-\u9FFF)，ー,－,a-z（A-Z）,空格,々
    let regexp5 = /[^\u30A1-\u30FC－‐\uff65-\uff9f\u3040-\u309fー\u4E00-\u9FFFa-zａ-ｚA-ZＡ-Ｚ0-9０-９\u0020\u0030\u3005]+/;
    //只允许输入字母和数字
    let regexp6 = /[^a-zA-Z0-9]+/
    // \ガ\ギ\グ\ゲ\ゴ\ザ\ジ\ズ\ゼ\ゾ\ダ\ヂ\ヅ\デ\ド\バ\ビ\ブ\ベ\ボ\ヴ\パ\ピ\プ\ペ\ポ
    //片假名(\u3040-\u30ff)()[\u0028\u0029\uff08\uff09]【验证口座名義】
    // let regexp8 = /[^\u30a0-\u30ff\u0028\u0029\uff08\uff09A-Z0-9\u002e\-/\ガ\ギ\グ\ゲ\ゴ\ザ\ジ\ズ\ゼ\ゾ\ダ\ヂ\ヅ\デ\ド\バ\ビ\ブ\ベ\ボ\ヴ\パ\ピ\プ\ペ\ポ]+/
    let regexp8=/[^\u30A1-\u30FC\uff08\uff09\u300c\u300d\u002f\u30fc\uff0e\uffe5]+/

    //法人名（公司名称）全角片假名,平假名,汉字，ー,a-z,a-z,々（全角）
    let regexp9 = /[^\u30A1-\u30FC\u3040-\u309fー‐\u4E00-\u9FFF\u3005a-zａ-ｚA-ZＡ-Ｚ\u0020\u3000]+/;

    //法人名允许输入部分特殊字符，全角片假名,平假名,ー,汉字，々，a-zａ-ｚA-ZＡ-Ｚ,空格
    let regexp10 = /[^\u30A1-\u30FC\u3040-\u309fー‐\u4E00-\u9FFF\u3005a-zａ-ｚA-ZＡ-Ｚ\u0020\u3000\&\',\-\.\·\＆\’\，\－\．\・\‘]+/;

    //法人名允许输入部分特殊字符，全角片假名,平假名,ー,汉字，々，a-zａ-ｚA-ZＡ-Ｚ,空格 数字
    let regexp11 = /[^\u30A1-\u30FC\u3040-\u309fー\u4E00-\u9FFF\u3005ａ-ｚＡ-Ｚ０-９\u3000\＆\’\，\－\．\・\‘]+/;

    //全角片假名,平假名,－，汉字，ー,a-z（A-Z）,々【内部者氏名】
    let regexp12 = /[^\u30A1-\u30FC－‐\u3040-\u309fー\u4E00-\u9FFFa-zａ-ｚA-ZＡ-Ｚ\u0030\u3005\u002d]+/;

    let regexp = '';
    switch (type) {
      case 1:
        regexp = regexp1;
        break;
      case 2:
        regexp = regexp2;
        break;
      case 3:
        regexp = regexp3;
        break;
      case 4:
        regexp = regexp4;
        break;
      case 5:
        regexp = regexp5;
        break;
      case 6:
        regexp = regexp6;
        break;
      case 7:
        regexp = regexp7;
        break;
      case 8:
        regexp = regexp8;
        break;
      case 9:
        regexp = regexp9;
        break;
      case 10:
        regexp = regexp10;
        break;
      case 11:
        regexp = regexp11;
        break;
      case 12:
        regexp = regexp12;
        break;
    }
    return !regexp.test(value);
  },
  //  半角数字转全角
  halfToFullangle(str,index=9) {
    return str.replace(
      /[A-Za-z0-9\uff0d\u2796\u30fc\u002d\uff70\u2014\u2013\u2212]/g,
      function (s) {
        if (s.match(/[\uff0d\u2796\u30fc\u002d\uff70\u2014\u2013\u2212]/)) {
          if (index === 0)  return '\u30fc';  //市区町村・町域名　カタカナ-ひらがな延長サウンドマーク
          if (index === 1)  return '\uff0d';  //番地　全角ハイフン-マイナス
          if (index === 2)  return s.match(/[\u002d]/) ? '\uff0d' : s.match(/[\uff0d]/) ? '\uff0d' :'\u30fc';//建物名・部屋番号等 ASCIIのハイフン->全角ハイフン-マイナス その他->カタカナ-ひらがな延長サウンドマーク
          else              return '\u30fc';  //index未定義 又は 上記以外 カタカナ-ひらがな延長サウンドマーク
        }
        return String.fromCharCode(s.charCodeAt(0) + 0xfee0);
      }
    );
  },

  // // remove localstorage
  // removeLocalstorage(name) {
  //     localStorage.removeItem(name)
  // },
  //判断长度为1的字符串是标准全角字符则返回1，是标准半角字符则返回0，其他情况返回-1
  isFullwidthChar(char) {
    try {
      let unicodeLen = char.charCodeAt(0).toString(16).length;
      if (unicodeLen == 4) {
        //标准全角
        return 1;
      }

      if (unicodeLen == 2) {
        //标准半角
        return 0
      }
    } catch (e) {
      // console.error(e);
      return -1;
    }
    return -1;
  },
  //判断字符串全部由全角字符组成则返回true，否则返回false
  isAllFullwidthStr(str) {
    try {
      for (let i in str) {
        if (this.isFullwidthChar(str[i]) == 0) {
          //存在半角字符
          return false;
        }
      }
      return true;
    } catch (e) {
      // console.error(e);
      return false;
    }
  },
  // 月，天在前面添加数字0
  fillTime(value) {
    return value.length == 1 ? '0' + value : value;
  },
  // 检测月日的时间格式
  verifyMonthDay(val) {
    const regex = /^(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|30|31)$/;
    let status = regex.test(val);
    if (status) {
      let m = val.split('-')[0];
      let d = val.split('-')[1];
      if (m == 4 || m == 6 || m == 9 || m == 11) {
        return status = d < 31 ? true : false;
      } else if (m == 2) {
        return status = d < 30 ? true : false;
      }
      return status;
    }
    return status;
  },
  // 检测 输入时间不能超过今日
  verifyDetaMAxToday(date) {
    var todayDate = new Date(Moment(new Date()).format('YYYY-MM-DD'));
    var oDate = new Date(date);
    if (todayDate.getTime() >= oDate.getTime()) {
      return true;
    }
    return false;
  },
  // 给名字输入框赋值
  PutName(value, putvalue) {
    return value.map((item, index) => {
      item.value = putvalue[index];
      return item;
    });
  },
  BackDialog() {
    $cErrorDialog({
      title: '',
      left: 'はい',
      right: 'いいえ',
      content: 'ご入力内容が反映されません。確認画面に戻りますか？',
      cancelBtn: true, //这个是启用取消按钮，
      confirm: () => {
      },
      cancel: () => {
        this.saveLocalLowerData('editCorporate', false, 'corporate');
        return router.push('/corporateConfirmInfo');
      }
    });
  },
  BackCorporate(path, comepath, isBack) {
    let falg = this.getLocalLowerData('editCorporate', 'corporate');
    if (path == '/corporateConfirmInfo') {
      if (isBack) {//不修改，返回修改页面
        return this.BackDialog();
      } else {//确定修改，返回修改页面
        this.saveLocalLowerData('editCorporate', false, 'corporate');
        return router.push('/corporateConfirmInfo');
      }
    }
    if (falg) {
      if (isBack) {//不修改，返回修改页面
        return this.BackDialog();
      } else {//确定修改，返回修改页面
        this.saveLocalLowerData('editCorporate', false, 'corporate');
        return router.push('/corporateConfirmInfo');
      }
    }
    if (!isBack) {
      // 進む場合URLを記憶する
      if (path.substring(0, 1) !== '/') comepath = '/' + comepath;
      this.saveLocalData('currentPage', comepath);
    }
    router.push(comepath);
  },

  disableEmojiInput(el) {
    if (el) {
      el.setAttribute(
        'onkeypress',
        'var ranges = [\
"[\u2700-\u27BF]",\
"[\uE000-\uF8FF]",\
"\uD83C[\uDC00-\uDFFF]",\
"\uD83D[\uDC00-\uDFFF]",\
"[\u2011-\u26FF]",\
"\uD83E[\uDD10-\uDDFF\uDE71-\uDE90\uDEB0-\uDEB3]"\
];\
var reg = new RegExp(ranges.join("|"), "g");\
return !reg.test(event.key);\
');
      // var unic = String.fromCharCode(event.keyCode);\
      // return !reg.test(unic);\
    }
  },
  eventScroll(el) {
    //记录滚动条高度
    if (el) {
      el.addEventListener('scroll', e => {
        sessionStorage.setItem('Main_scroll', el.scrollTop)
      }, false)
    }
  },
  //remove emoji and space
  removeEmojiNSpace(value) {
    const ranges = [
      '[\u2700-\u27BF]',
      '[\uE000-\uF8FF]',
      '\uD83C[\uDC00-\uDFFF]',
      '\uD83D[\uDC00-\uDFFF]',
      '[\u2011-\u26FF]',
      '\uD83E[\uDD10-\uDDFF\uDE71-\uDE90\uDEB0-\uDEB3]'
    ];
    let reg = new RegExp(ranges.join('|'), 'g');
    return value.replace(reg, '');
  },
  //去掉首尾的空格(全角和半角)，将中间的半角空格转成全角
  trimAndTransSpace(value) {
    return value.trim().replace(/\u0020/g, '　').replace(/\u3000/g, '　');//'\u3000');
  },

  //特殊字符转换
  transformSpecialChar(value) {
    let specialCharArr = ['&', '\'', ',', '-', '.', '·', '‘'] //半角字符
    let specialCharArrA = ['＆', '’', '，', '－', '．', '・', '’'] //全角字符
    specialCharArr.forEach((item, index) => {
      value = value.replaceAll(item, specialCharArrA[index])
    })
    return value
  },

  //convert characters from half-width to full-width 半角转全角
  hankaku2Zenkaku(str) {
    return str.replace(/[A-Za-z0-9\uff0d\u2796\u30fc\u002d\uff70\u2014\u2013\u2212]/g, function (s) {
      if (s.match(/[\uff0d\u2796\u30fc\u002d\uff70\u2014\u2013\u2212]/)) {
        return '\u30fc';
      }
      return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
    });
  },
  toFullZenkana(value) {
    var beforeStr = ['･', 'ｧ', 'ｨ', 'ｩ', 'ｪ', 'ｫ', 'ｬ', 'ｭ', 'ｮ', 'ｯ', 'ｰ', 'ｳﾞ', 'ｶﾞ', 'ｷﾞ', 'ｸﾞ', 'ｹﾞ', 'ｺﾞ', 'ｻﾞ', 'ｼﾞ', 'ｽﾞ', 'ｾﾞ', 'ｿﾞ', 'ﾀﾞ', 'ﾁﾞ', 'ﾂﾞ', 'ﾃﾞ', 'ﾄﾞ', 'ﾊﾞ', 'ﾋﾞ', 'ﾌﾞ', 'ﾍﾞ', 'ﾎﾞ', 'ﾊﾟ', 'ﾋﾟ', 'ﾌﾟ', 'ﾍﾟ', 'ﾎﾟ', 'ｱ', 'ｲ', 'ｳ', 'ｴ', 'ｵ', 'ｶ', 'ｷ', 'ｸ', 'ｹ', 'ｺ', 'ｻ', 'ｼ', 'ｽ', 'ｾ', 'ｿ', 'ﾀ', 'ﾁ', 'ﾂ', 'ﾃ', 'ﾄ', 'ﾅ', 'ﾆ', 'ﾇ', 'ﾈ', 'ﾉ', 'ﾊ', 'ﾋ', 'ﾌ', 'ﾍ', 'ﾎ', 'ﾏ', 'ﾐ', 'ﾑ', 'ﾒ', 'ﾓ', 'ﾔ', 'ﾕ', 'ﾖ', 'ﾗ', 'ﾘ', 'ﾙ', 'ﾚ', 'ﾛ', 'ﾜ', 'ｦ', 'ﾝ'];
    var afterStr = ['・', 'ァ', 'ィ', 'ゥ', 'ェ', 'ォ', 'ャ', 'ュ', 'ョ', 'ッ', 'ー', 'ヴ', 'ガ', 'ギ', 'グ', 'ゲ', 'ゴ', 'ザ', 'ジ', 'ズ', 'ゼ', 'ゾ', 'ダ', 'ヂ', 'ヅ', 'デ', 'ド', 'バ', 'ビ', 'ブ', 'ベ', 'ボ', 'パ', 'ピ', 'プ', 'ペ', 'ポ', 'ア', 'イ', 'ウ', 'エ', 'オ', 'カ', 'キ', 'ク', 'ケ', 'コ', 'サ', 'シ', 'ス', 'セ', 'ソ', 'タ', 'チ', 'ツ', 'テ', 'ト', 'ナ', 'ニ', 'ヌ', 'ネ', 'ノ', 'ハ', 'ヒ', 'フ', 'ヘ', 'ホ', 'マ', 'ミ', 'ム', 'メ', 'モ', 'ヤ', 'ユ', 'ヨ', 'ラ', 'リ', 'ル', 'レ', 'ロ', 'ワ', 'ヲ', 'ン'];
    var fullStr = value;
    for (var i = 0; i < beforeStr.length; i++) {
      fullStr = fullStr.replace(new RegExp(beforeStr[i], 'g'), afterStr[i]);
    }
    return fullStr;
  },
  ToCDB(str) {
    //半角转全角
    var tmp = '';
    for (var i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 65248 && str.charCodeAt(i) < 65375) {
        tmp += String.fromCharCode(str.charCodeAt(i) - 65248);
      } else {
        tmp += String.fromCharCode(str.charCodeAt(i));
      }
    }
    return tmp
  },
  // 根据id 来改变数组的值  用来选中弹框的回显
  dataAccordingtoId(data, id) {
    return data.map(item => {
      if (item.id == id) {
        item.isActive = true
      }
      return item;
    })
  },
  getNextJump(next) {
    return this.jumpList[next];
  },
  getDate(y, m, d) {
    var year = y + '-';
    var month =
      (m < 10 ? '0' : '') + parseInt(m) + '-';
    var day = (d < 10 ? '0' : '') + parseInt(d);
    return year + month + day;
  },

  deepCopy(data) {
    return JSON.parse(JSON.stringify(data))
  },

  getOrientation(file) {
    //获取照片的拍照信息
    return new Promise(resolve => {
      let Orientation = null
      EXIF.getData(file, function () {
        Orientation = EXIF.getTag(this, 'Orientation')
        resolve(Orientation);
      })
    })
  },
  compressImg(file, quality = 0.8) {
    //图片处理
    return new Promise((resolve) => {
      this.getOrientation(file).then((Orientation) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          img.src = reader.result;
        };
        let img = new Image(),
          height = 1500,
          width = 0,
          quality = quality, //image quality  压缩质量
          canvas = document.createElement('canvas'),
          drawer = canvas.getContext('2d');
          img.onload = function () {
          if (img.height > 1500 ){
            //resize the image when height is longer than 1500px
            width = height * (img.width / img.height);
          }else{
            height = img.height;
            width = img.width;
          }
          canvas.height = height;
          canvas.width = width;

          if (Orientation == 6) {
            //顺时针旋转90°
            canvas.height = width;
            canvas.width = height;
            drawer.rotate(Math.PI / 2);
            drawer.drawImage(img, 0, -height, width, height);
          } else if (Orientation == 3) {
            //顺时针旋转180°
            drawer.rotate(Math.PI);
            drawer.drawImage(img, -width, -height, width, height);
          } else if (Orientation == 8) {
            //逆时针旋转90°
            canvas.height = width;
            canvas.width = height;
            drawer.rotate(3 * Math.PI / 2);
            drawer.drawImage(img, -width, 0, width, height);
          } else {
            //默认
            canvas.height = height;
            canvas.width = width;
            drawer.drawImage(img, 0, 0, width, height);
          }

          let base64 = canvas.toDataURL('image/jpeg', quality); //压缩后的base64图片

          resolve(base64)
        };
      })
    })

  },

  //普通的图片处理
  compressOrdinaryImg(file) {
    return new Promise((resolve) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        img.src = reader.result;
      };
      let img = new Image(),
        height = 480,
        quality = 0.8, //image quality  压缩质量
        canvas = document.createElement('canvas'),
        drawer = canvas.getContext('2d');
      img.onload = function () {
        canvas.height = height;
        canvas.width = height * (img.width / img.height);
        drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
        let base64 = canvas.toDataURL('image/jpeg', quality); //压缩后的base64图片
        resolve(base64)
      };
    })
  },

  baseToFlie(base64Img) {
    base64Img = base64Img.search('base64') != -1 ? base64Img : 'data:image/jpg;base64,' + base64Img;

    let arr = base64Img.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    let fileurl = new File([u8arr], {type: mime});
    if (fileurl) {
      return fileurl;
    } else {
      return ''
    }
  },
  // 返回提示语言
  changeTips() {
    $cErrorDialog({
      title: '',
      left: 'はい',
      right: 'いいえ',
      content: 'ご入力内容が反映されません。確認画面に戻りますか？',
      cancelBtn: true, //这个是启用取消按钮，
      confirm: () => {
      },
      cancel: () => {
        return router.push('/corporateConfirmInfo');
      }
    });
  },
  /**
   * 获取本地再提出数据
   * @param field 字段
   * @param type
   * @param localName
   * @returns {any}
   */
  getResetFieldVal(field, type = 'USER', localName = 'resetData') {
    if (field) {
      let resetData = JSON.parse(localStorage.getItem(localName));
      if (field == 'REAPPLY_TYPE_LIST' || field == 'rt') {
        return resetData[field];
      }
      return resetData[type][field]
    } else {
      return JSON.parse(localStorage.getItem(localName))[type]
    }
  },
  /**
   * 修改再提出本地存储的数据(不传入field保存所用数据)
   * @param Val  保存的值
   * @param field 保存的字段
   * @param type 类型（值）
   * @param localName 本地存储的名称
   */
  setResetFieldVal(Val, field, type = 'USER', localName = 'resetData') {
    if (field) {
      let data = JSON.parse(localStorage.getItem(localName));
      if ('USER' == type || 'MY_NUMBER_IDENTITY' == type || 'COMPANY_IMAGE' == type) {
        data[type][field] = Val;
      } else {
        data[field] = Val;
      }
      localStorage.setItem(localName, JSON.stringify(data));
    } else {
      localStorage.setItem(localName, JSON.stringify(Val));
    }
  },
  // 再提出处理实际支配者信息
  getBeneficialArr(da) {
    let data = [{}, {}, {}, {}, {}];
    let arr = data.map((item, index) => {
      let type = 'BENEFICIAL_OWNER_TYPE' + parseInt(index + 1);
      let name = 'BENEFICIAL_OWNER_CORPORATION_TYPE' + parseInt(index + 1);
      let code = 'BENEFICIAL_OWNER_NAME' + parseInt(index + 1);
      let categ = 'BENEFICIAL_OWNER_KANA_NAME' + parseInt(index + 1);
      let obj = {
        BENEFICIAL_OWNER_TYPE: da[type],
        BENEFICIAL_OWNER_CORPORATION_TYPE: da[name],
        BENEFICIAL_OWNER_NAME: da[code],
        BENEFICIAL_OWNER_KANA_NAME: da[categ],
        FATHERINDEX:index
      };
      return obj;
    });
    return arr.filter((item) => {
      return item.BENEFICIAL_OWNER_TYPE != null;
    });
  },

  selectDataToId(id, datalist) {
    let result = {};
    datalist.forEach((data) => {
      if (data.id == id) {
        result = data.value;
      }
    });
    return result;
  },

  chengelocalStorageData(date) {
    //localStorage.clear();
    let params = {
      //EMAIL: sto.email.email, //邮箱
      //PASSWORD: this.commonJs.hashPwd(sto.pwd || ''), //密码
      //FOREIGN_PEPS_FLG: 0,
      //AMERICA_TAX_FLG: 0,
      //ANTISOCIAL_FLG: 0,
      //CONFIRMED_ELECTRONICS_INFO: this.getConsentData(), //同意书没有了
      nameInfo: {
        seiName: date.NAME.split('　'),
        KanaName: date.KANA_NAME.split('　'),
        sex: date.SEX,
        year: date.BIRTH_D.split('-')[0],
        month: date.BIRTH_D.split('-')[1],
        day: date.BIRTH_D.split('-')[2],
      },
      nationalty: {
        nationaltyId: date.NATIONALTY
      },
      address: {
        postalCode: date.POSTAL_CD,
        searchedPostal: {
          address1: date.ADDRESS1,
          address2: date.ADDRESS2,
          address3: date.ADDRESS3,
          address4: date.ADDRESS4 ? date.ADDRESS4 : '',
          area_cd: date.AREA_CD,
        },
        address1: date.ADDRESS1,
        address2: date.ADDRESS2,
        housenumber: date.ADDRESS3,
        roomnumber: date.ADDRESS4 ? date.ADDRESS4 : '',
        roomnumber_kana: date.ADDRESS4_KANA ? date.ADDRESS4_KANA : '',
      },
      isSameAddress: {
        id: date.STATE_FLG,
      },
      nowaddress: {
        address1: '',
        addressId: date.STATE_CD,
        address2: date.STATE_ADDRESS2
      },
      tel: date.TEL_NO_02,
      tel_fixed: date.TEL_NO_01,
      back_obj: {
        organizationName: date.WITHDRAW_FACIL_NAME,
        branch: date.WITHDRAW_SUB_NAME,
        accountType: {
          id: date.WITHDRAW_ACCOUNT_TYPE,
          value: this.selectDataToId(date.WITHDRAW_ACCOUNT_TYPE, commonData.accountTypeData),
        },
        accountNum: date.WITHDRAW_ACCOUNT_NUMBER,
        selectedBranchData: {
          WITHDRAW_SUB_NAME: date.WITHDRAW_SUB_NAME,
          WITHDRAW_SUB_CODE: date.WITHDRAW_SUB_CD,
          value: date.WITHDRAW_SUB_NAME,
          id: date.WITHDRAW_SUB_CD
        },
        selectedOrganizeData: {
          WITHDRAW_FACIL_CODE: date.WITHDRAW_FACIL_CD,
          WITHDRAW_FACIL_NAME: date.WITHDRAW_FACIL_NAME,
          ONLINE_ORDINARY: 0,
          value: date.WITHDRAW_FACIL_NAME,
          id: date.WITHDRAW_FACIL_CD
        }
      },
      occuption: {
        occuptionType: {
          id: date.OCCUPATION_TYPE,
          value: this.selectDataToId(date.OCCUPATION_TYPE, commonData.occuptionTypeData),
        },
        employname_obj: {
          employment: date.EMPLOYMENT,
          department: date.DEPARTMENT,
          position: date.POSITION,
          business: {
            id: date.BUSINESS_CATEGORY,
            value: this.selectDataToId(date.BUSINESS_CATEGORY, commonData.businessData),
          }
        }
      },
      insider: {
        insiderType: {
          id: date.INSIDER_FLG,
          value: this.selectDataToId(date.INSIDER_FLG, commonData.insiderTypeData),
        },
        insiderTypeArr: [
          {
            selectArr: [
              {
                id: date.INSIDER_ARR[0].INSIDER_COMPANY_TYPE,
                value: this.selectDataToId(date.INSIDER_ARR[0].INSIDER_COMPANY_TYPE, commonData.companyTypeData),
              },
              {
                id: date.INSIDER_ARR[1].INSIDER_COMPANY_TYPE,
                value: this.selectDataToId(date.INSIDER_ARR[1].INSIDER_COMPANY_TYPE, commonData.companyTypeData),
              }
            ],
            selectType: {
              id: date.INSIDER_ARR[0].INSIDER_COMPANY_TYPE,
              value: this.selectDataToId(date.INSIDER_ARR[0].INSIDER_COMPANY_TYPE, commonData.companyTypeData),
            },
            insiderType: {
              id: date.INSIDER_ARR[0].INSIDER_TYPE,
              value: this.selectDataToId(date.INSIDER_ARR[0].INSIDER_TYPE, commonData.internalTiesData),
            },
            brandCode: date.INSIDER_ARR[0].INSIDER_BRAND_CD,
            personName: date.INSIDER_ARR[0].INSIDER_FAMILY_NAME,
          },
          {
            selectType: {
              id: date.INSIDER_ARR[1].INSIDER_COMPANY_TYPE,
              value: this.selectDataToId(date.INSIDER_ARR[1].INSIDER_COMPANY_TYPE, commonData.companyTypeData),
            },
            insiderType: {
              id: date.INSIDER_ARR[1].INSIDER_TYPE,
              value: this.selectDataToId(date.INSIDER_ARR[1].INSIDER_TYPE, commonData.internalTiesData),
            },
            brandCode: date.INSIDER_ARR[1].INSIDER_BRAND_CD,
            personName: date.INSIDER_ARR[1].INSIDER_FAMILY_NAME,
          },
        ]
      },
      invest: {
        questionMotive: {
          motive_type: {
            id: date.MOTIVE_TYPE,
            value: this.selectDataToId(date.MOTIVE_TYPE, commonData.questionMotiveData),
          },
          campaign_code: date.MOTIVE_OTHER,
        },
        purpose: {
          id: date.PURPOSE_TYPE,
          value: this.selectDataToId(date.PURPOSE_TYPE, commonData.purposeData),
        },
        income: {
          id: date.INCOME_TYPE,
          value: this.selectDataToId(date.INCOME_TYPE, commonData.IncomeData),
        },
        revenuetype: {
          id: date.REVENUE_TYPE,
          value: this.selectDataToId(date.REVENUE_TYPE, commonData.revenueData),
        },
        asset: {
          id: date.FINANCIAL_ASSET_TYPE,
          value: this.selectDataToId(date.FINANCIAL_ASSET_TYPE, commonData.assetData),
        },
        //投資資金の内容 INVESTMENT_CAPITAL_TYPE
        asstsType: {
          id: date.INVESTMENT_CAPITAL_TYPE,
          value: this.selectDataToId(date.INVESTMENT_CAPITAL_TYPE, commonData.assetTypeData),
        },
        otherType: date.INVESTMENT_CAPITAL_DETAIL,
        experience: {
          id: date.EXPERIENCE_STOCK_TYPE,
          value: this.selectDataToId(date.EXPERIENCE_STOCK_TYPE, commonData.experienceData),
        },
        experienceDerivative: {
          id: date.EXPERIENCE_LEVERAGE_TYPE,
          value: this.selectDataToId(date.EXPERIENCE_LEVERAGE_TYPE, commonData.experienceFundData),
        },
        experienceFund: {
          id: date.EXPERIENCE_DERIVATIVE_TYPE,
          value: this.selectDataToId(date.EXPERIENCE_DERIVATIVE_TYPE, commonData.derivativeData),
        },
        goods: {
          other: date.DESIRED_INVESTMENT_TYPE_OTHER,
          goods: [
            {
              id: date.DESIRED_INVESTMENT_TYPE,
              value: this.selectDataToId(date.DESIRED_INVESTMENT_TYPE, commonData.investGoodsData),
            }
          ]
        }
      },
      mailInfoFlg: {
        id: date.MAIL_INFO_FLG,
        value: this.selectDataToId(date.MAIL_INFO_FLG, commonData.mailInfoFlg),
      },
    }
    return params;
  },

  //验证是否不备
  verifyStandard(key, fieldArr) {
    let arr = JSON.parse(localStorage.getItem('resetData')).REAPPLY_TYPE_LIST.FAILED_TYPES;
    /**
     法他证明书 LEGAL PERSON
     代表者本人 REPRESENT
     实质支配者 BENEFICIAL_OWNER
     取引责任者 LEGAL_AGENT
     */
      // let arr=['LEGAL_PERSON','REPRESENT','LEGAL_AGENT','BENEFICIAL_OWNER'];
    let status = true;
    if (arr.includes(key)) {
      status = false
    }
    fieldArr.forEach((item) => {
      this.setResetFieldVal(status, item, 'COMPANY_IMAGE')
    })
  },

  // 画面遷移
  // saveCurrentPage: true保存／false保存しない。遷移先の画面のURLをcurrentPageに保存するかどうか。次回はそこに復活する。
  toNext(url, query, saveCurrentPage) {
    if (saveCurrentPage) {
      if (url.substring(0, 1) !== '/') url = '/' + url;
      this.saveLocalData('currentPage', url);
    }
    router.push({path: url, query: query})
  },

  // currentPageをクリアする
  clearCurrentPage() {
    this.saveLocalData('currentPage', '/');
  },
  // 隐藏邮箱中间几位
  regEmail(email) {
    if(!email) return ''
    let star = ''
    if (String(email).indexOf('@') > 0) {
      let str = email.split('@')
      if (str[0].length > 3) {
        for (let i = 0; i < str[0].length - 3; i++) {
          star += '*'
        }
      }else{
        return email
      }
    }

    let ref = /(.{2}).+(.{1}@.+)/g;
    let new_email = email.replace(ref,'$1'+star+'$2');

    return new_email
  },
  // 電話番号のマスキング
  regTel(tel) {
    if(!tel) return ''
    let star = ''
    for (let i = 0; i < tel.length -4; i++) {
      star += '*'
    }
    let new_tel = star+tel.slice(-4);
    return new_tel
  },
  // 異なるアカウントステータス、対応する画面アドレスの取得
  getDocumentPath(userInfo){

    let userType = userInfo.PERSON_CORP_TYPE // 1個人 2法人
    let userStatus = userInfo.APPLICANT_STATUS
    // APPLICANT_STATUS
    // 区分 申込状態
    // 個人 0．仮申込待ち
    //     1．マイナンバー提出待ち
    //     2．eKYC連携ID生成待ち
    //     3．eKYC認証待ち
    //     4．eKYC認証済み
    //     5．本申込完了
    // 法人 0．仮申込待ち
    //     1．本人確認提出待ち
    //     2．本人確認提出済み
    //     5．本申込完了

    if(userType == 1){
      if(userStatus == 0){
        return '/documentVerifySetEmail' // R-001 メールまたは電話番号入力
      }else if(userStatus == 1){
        return '/identityDocumentsType' // S-001 説明・マイナンバー選択
      }else if(userStatus == 2 || userStatus == 3){
        if(userStatus == 3 && userInfo.URL) return userInfo.URL // EKYC 認証済みの場合、レスポンスにDATA.URL = "/Register/SelfConfirm?i=該当Hashコード"を追加する
        return '/onlineConfirm' // S-010 本人確認前
      }else if(userStatus == 4){
        return '/Register/SelfConfirm' // S-012 申請完了ポップアップ
      }else if(userStatus == 5){
        return '/Register/Over' // S-013 申込み完了
      }
    }else if(userType == 2){
      let ownerInfo = userInfo.BENEFICIAL_OWNER_ARR.filter(item=>item.length != 0)

      let tempArr = userInfo.BENEFICIAL_OWNER_IMAGE_DATA_ARR.filter(item=>item.length !=0)

      let ownerImgs = tempArr.filter(item=>item.BENEFICIAL_OWNER_IMAGE_DATA.length != 0)
      if(userStatus == 0){
        return '/documentVerifySetEmail' // R-001 メールまたは電話番号入力
      }else if(userStatus == 5){
        return '/Register/Over' // S-013 申込み完了
      }else if(userInfo.REPRESENT_IMAGE_DATA_ARR.length == 0){
        return '/representativeIdentityDocumentsType' // T-002 代表者書類選択
      }else if(userInfo.LEGAL_AGENT_IMAGE_DATA_ARR.length == 0 && userInfo.LEGAL_AGENT_REPRESENT_SAME_PERSON == 0){
        //LEGAL_AGENT_REPRESENT_SAME_PERSON 代表者と責任者が同一人物かどうか 0：同一人物でない 1：同一人物
        return '/transactionManagerIdentityDocumentsType' //T-006 取引責任者書類選択
      }else if(ownerInfo.length != 0 && ownerImgs == 0){
        return '/rulerIdentityDocumentsUpload' // T-009 実質的支配者本人確認書類
      }
    }
    return '/documentVerifySetEmail'  // R-001 メールまたは電話番号入力
  },
  encryptedData(key,rawData){

       const bufferData = Buffer.from(rawData, 'utf8');

       const encryptedData = crypto.publicEncrypt({
           key: key,
           padding: crypto.constants.RSA_PKCS1_PADDING
       }, bufferData);

       const base64EncryptedData = encryptedData.toString('base64');

       return base64EncryptedData
  }
}




// WEBPACK FOOTER //
// ./src/utils/common-js.js